import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Nav,
  NavbarContainer,
  Span,
  NavLogo,
  NavItems,
  GitHubButton,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  MobileLink,
  Avatar,
} from "./NavbarStyledComponent";
import { FaBars, FaTimes } from "react-icons/fa";
import { Bio } from "../../data/constants";

const links = [
  { label: "About", to: "/about" },
  { label: "Skills", to: "/#skills" },
  { label: "Experience", to: "/#experience" },
  { label: "Projects", to: "/projects" },
  { label: "Education", to: "/#education" },
  { label: "Contact", to: "/contact" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    setIsOpen(false);
  }, [location.pathname, location.hash]);

  const isCurrent = (to) => !to.includes("#") && location.pathname === to;

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to="/">
          <Avatar>
            <img
              src={`${process.env.PUBLIC_URL}/navbar-photo.png`}
              alt="Saroj Giri"
            />
          </Avatar>
          <Span>Saroj Giri</Span>
        </NavLogo>

        <MobileIcon>
          <button
            type="button"
            aria-label={isOpen ? "Close menu" : "Open menu"}
            aria-expanded={isOpen}
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </MobileIcon>

        <NavItems>
          {links.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className={isCurrent(link.to) ? "active" : undefined}
              aria-current={isCurrent(link.to) ? "page" : undefined}
            >
              {link.label}
            </Link>
          ))}
        </NavItems>

        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank" rel="noopener noreferrer">
            GitHub
          </GitHubButton>
        </ButtonContainer>

        {isOpen && (
          <MobileMenu>
            {links.map((link) => (
              <MobileLink key={link.label} to={link.to} onClick={() => setIsOpen(false)}>
                {link.label}
              </MobileLink>
            ))}
            <GitHubButton
              style={{ padding: "12px 16px", width: "max-content" }}
              href={Bio.github}
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </GitHubButton>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
